import React, { useRef } from 'react';
import { IonModal } from '@ionic/react';
import {
	BottomSheetInner,
	VTDescription,
	VTDescriptionContainer,
} from '../virtualTourStyles';

type DescriptionBottomSheetProps = {
	sheetOpen: boolean;
	setSheetOpen: React.Dispatch<React.SetStateAction<any>>;
	description: any;
};
const DescriptionBottomSheet: React.FC<DescriptionBottomSheetProps> = ({
	sheetOpen,
	setSheetOpen,
	description,
}) => {
	const sheetModal = useRef<HTMLIonModalElement>(null);
	return (
		<IonModal
			keepContentsMounted={true}
			onDidDismiss={() => setSheetOpen(false)}
			ref={sheetModal}
			isOpen={sheetOpen}
			initialBreakpoint={0.95}
			breakpoints={[0, 0.95]}>
			<BottomSheetInner>
				<VTDescriptionContainer>
					{/* <VTGradient /> */}
					<VTDescription>{description}</VTDescription>
				</VTDescriptionContainer>
			</BottomSheetInner>
		</IonModal>
	);
};

export default DescriptionBottomSheet;
